// removed by extract-text-webpack-plugin
module.exports = {"container":"_3lmhx5PKFWkAwyHkJy-u4L","avatar":"_3tyBA0snsHzdERDcbA5wsj","details":"_2shMphEUyXuzaXZjmo-u-8","noPhoneNumbers":"_1wro4T0U1NXpMGuIkiKHUm"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aae5d430","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/SearchContacts/SearchMode/ContactComponent.less
// module id = xJ7m
// module chunks = 1